import { useState } from 'react';

import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';

import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';

const emptyForm = { firstname: '', lastname: '', email: '', phone: '', message: '' };

const ContactsComponent = () => {
	const [formData, setFormData] = useState(emptyForm);
	// IDLE while filling in, SENDING between submit and the response, then SUCCESS
	// or FAILED — the visitor gets no confirmation at all otherwise.
	const [sendStatus, setSendStatus] = useState('IDLE');

	const handleSubmit = async (e: React.FormEvent) => {
		e.preventDefault();
		setSendStatus('SENDING');

		try {
			const response = await fetch('/api/messages', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify(formData),
			});
			const data = await response.json();

			if (response.ok && data.operation === 'SUCCESS') {
				setFormData(emptyForm);
				setSendStatus('SUCCESS');
			} else {
				setSendStatus('FAILED');
			}
		} catch (error) {
			console.error('Failed to send message:', error);
			setSendStatus('FAILED');
		}
	};

	return (
		<div className="min-h-screen" style={{ backgroundColor: '#e6e6b8' }}>
			<div className="top-0 z-10000 w-full px-0 py-3 sm:p-6">
				<Navbar />
			</div>

			<div className="flex items-center justify-center p-4 sm:p-10" style={{ backgroundColor: '#e6e6b8' }}>
				<div className="w-full max-w-[800px]">
					<div className="rounded-2xl border bg-card p-5 shadow-elevated sm:p-10" style={{ backgroundColor: '#ffe600' }}>
						<div className="text-center font-bold text-2xl">تواصل معنا</div>
						<div className="py-6"></div>
						<form onSubmit={handleSubmit} className="space-y-4">
							<div className="flex flex-col gap-4 sm:flex-row">
								<div className="w-full min-w-0 space-y-2">
									<Label htmlFor="firstname" className="font-bold">
										الإسم
									</Label>
									<Input
										id="firstname"
										type="text"
										placeholder=""
										className="text-right"
										style={{ borderColor: 'green' }}
										value={formData.firstname}
										onChange={(e) => setFormData({ ...formData, firstname: e.target.value })}
										required
									/>
								</div>
								<div className="w-full min-w-0 space-y-2">
									<Label htmlFor="lastname" className="font-bold">
										اللقب
									</Label>
									<Input
										id="lastname"
										type="text"
										placeholder=""
										className="text-right"
										style={{ borderColor: 'green' }}
										value={formData.lastname}
										onChange={(e) => setFormData({ ...formData, lastname: e.target.value })}
										required
									/>
								</div>
							</div>

							<div className="flex flex-col gap-4 sm:flex-row">
								<div className="w-full min-w-0 space-y-2">
									<Label htmlFor="email" className="font-bold">
										البريد الإلكتروني
									</Label>
									<Input
										id="email"
										type="email"
										placeholder=""
										style={{ borderColor: 'green' }}
										value={formData.email}
										onChange={(e) => setFormData({ ...formData, email: e.target.value })}
									/>
								</div>

								<div className="w-full min-w-0 space-y-2">
									<Label htmlFor="phone" className="font-bold">
										رقم الهاتف
									</Label>
									<Input
										id="phone"
										type="text"
										placeholder=""
										style={{ borderColor: 'green' }}
										value={formData.phone}
										onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
									/>
								</div>
							</div>

							<div className="space-y-2">
								<Label htmlFor="message" className="font-bold">
									الرسالة
								</Label>
								<Textarea
									id="message"
									placeholder=""
									required
									className="text-right"
									style={{ borderColor: 'green' }}
									value={formData.message}
									onChange={(e) => setFormData({ ...formData, message: e.target.value })}
								/>
								<Label dir="rtl">شاركنا أفكارك حول خدمتنا.</Label>
							</div>
							<br />

							{sendStatus === 'SUCCESS' && (
								<div className="text-center font-bold" dir="rtl" style={{ color: 'green' }}>
									تم إرسال رسالتك بنجاح، سنتواصل معك قريبا
								</div>
							)}

							{sendStatus === 'FAILED' && (
								<div className="text-center font-bold" dir="rtl" style={{ color: 'red' }}>
									تعذر إرسال الرسالة، الرجاء المحاولة مرة أخرى
								</div>
							)}

							<br />

							<Button type="submit" className="w-full" size="lg" disabled={sendStatus === 'SENDING'}>
								{sendStatus === 'SENDING' ? 'جاري الإرسال...' : 'اترك رسالة'}
							</Button>
						</form>
					</div>
				</div>
			</div>
			<br />
			<br />
			<br />

			<Footer />
		</div>
	);
};

export default ContactsComponent;
